import createUseBondScreenerSidebarFilter from '@/creditflowresearch/application/BondScreener/Sidebar/createUseBondScreenerSidebarFilter';
import type { IFilterBoundaryRegion, ICorporateBondScreenerFilterBoundaries, TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import { DEFAULT_FILTERS } from '../buildCorporateBondScreenerRequest';

const useCorporateBondScreenerSidebarFilter = createUseBondScreenerSidebarFilter<
  TFilterPayload,
  ICorporateBondScreenerFilterBoundaries,
  IFilterBoundaryRegion
>({
  filterType: 'corp',
  defaultFilters: DEFAULT_FILTERS,
  resetPreservedKeys: [],
});

export default useCorporateBondScreenerSidebarFilter;
export type { TFilterPayload };
